import React from "react"
import { Box, SimpleGrid, Text } from "@chakra-ui/react"
import { WhatsAppTemplate } from "sharedTypes"
import TextTemplateCard from "./TextTemplateCard"

type Props = {
  templates: WhatsAppTemplate[]
  selectedTemplate: WhatsAppTemplate | null
  onSelectTemplate: (template: WhatsAppTemplate) => void
  channel: "sms" | "whatsapp"
}

const TemplateGrid = ({
  templates, selectedTemplate, onSelectTemplate, channel,
}: Props) => {
  if (templates.length === 0) {
    return (
      <Box p={8} textAlign="center">
        <Text color="gray.500">No templates match your filters.</Text>
      </Box>
    )
  }

  return (
    <SimpleGrid columns={2} spacing={4}>
      {templates.map((template) => (
        <TextTemplateCard
          key={template.contentSid}
          template={template}
          selected={selectedTemplate?.contentSid === template.contentSid}
          onClick={() => onSelectTemplate(template)}
          channel={channel}
        />
      ))}
    </SimpleGrid>
  )
}

export default TemplateGrid
